import React from "react";
import MultiFaceSwapTemplate from "../../components/MultiFaceSwapTemplate";
import { BabyshowerFeatures } from "../../components/Features";
import { BabyshowerHeroSection } from "../../components/HeroSection";
import { BabyshowerFAQ } from "../../components/faqs";
import { BabyshowerGuide } from "../../components/sections/FaceSwapGuide";
import { WhoCanUseBabyshower } from "../../components/sections/WhoCanUseSnapToon";
import { BabyshowerBenefits } from "../../components/sections/SnapToonBenefits";
import { ChildCare } from "@mui/icons-material";

const BabyshowerFaceSwap: React.FC = () => {
  return (
    <MultiFaceSwapTemplate
      initialSwappedImage="https://snaptoon-development.s3.eu-north-1.amazonaws.com/snaptoon_web/baby-shower/baby_shower_4.jpg"
      toastPrefix="Baby Shower"
      badgeIcon={<ChildCare sx={{ fontSize: 18, color: "#c084fc" }} />}
      badgeText="Baby Shower AI Swap"
      heroHeading="Baby Shower AI Face Swap – Cute & Memorable Baby Themes"
      heroSubheading="Delightful Baby & Maternity Photo Concept Creations"
      heroText="Baby Shower AI Face Swap is an intelligent tool designed to transform family, pregnancy announcement, and baby shower photos! Place parents-to-be, family members, and friends into adorable baby shower themes, gender reveal concepts, and maternity photoshoot templates effortlessly with SwapToon's advanced AI face swap engine."
      HeroSectionComponent={BabyshowerHeroSection}
      FeaturesComponent={BabyshowerFeatures}
      GuideComponent={BabyshowerGuide}
      WhoCanUseComponent={WhoCanUseBabyshower}
      BenefitsComponent={BabyshowerBenefits}
      FAQComponent={BabyshowerFAQ}
    />
  );
};

export default BabyshowerFaceSwap;
